import { RouterOutput } from "@mindlercare/mindlerapi-client";
import type {
  CreatePsychologistComment,
  CreatePsychologistComments,
  PsychologistComments,
} from "./type";

export const filterPsychologistComments = (
  psychologistComments: PsychologistComments,
  countryId: number,
): CreatePsychologistComments =>
  psychologistComments?.filter(
    (comment) => comment.countryLanguage.countryId === countryId,
  );

type GetCommentProps = {
  activeCountry: RouterOutput["application"]["markets"][0];
  comments?: CreatePsychologistComment[];
  defaultLanguageId?: number;
};
export const getComments = ({
  comments,
  activeCountry,
}: GetCommentProps): CreatePsychologistComments => {
  if (comments?.length) {
    return comments;
  }

  return activeCountry.languages.map((language) => ({
    countryLanguage: {
      countryId: activeCountry.countryId,
      languageId: language.languageId,
    },
    comment: "",
  }));
};

export const getUpdatedComment = (
  previousComments: CreatePsychologistComments,
  countryId: number,
  languageId: number,
  newValue: string,
): CreatePsychologistComments =>
  previousComments.map((comment) =>
    comment.countryLanguage.countryId === countryId &&
    comment.countryLanguage.languageId === languageId
      ? { ...comment, comment: newValue }
      : comment,
  );
